<require from="./my-app.scss"></require>
<import from="./views/top-nav-bar/top-nav-bar"></import>
<import from="./views/main-body-tab-bar/main-body-tab-bar"></import>

<import from="./styles/roboto.css"></import>
<import from="./styles/material_icons.css"></import>


<div class="menu">
    <top-nav-bar></top-nav-bar>
</div>
<main-body-tab-bar></main-body-tab-bar>
